import {GlobalEventQueue} from "./global-event-queue";

export const OnGlobalKeyDownEnter = GlobalEventQueue({
    eventName: "keydown",
    surCheck: (e) => e.key === "Enter",
});
